import * as React from 'react';
import { observer, Provider } from 'mobx-react';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { observable } from 'mobx';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { Switch, Route } from 'react-router';
import { V3Routes } from '../../routes';
import { ApplicationPageSummaryPane } from '../../components/organisms/application/ApplicationPageSummaryPane';
import { ApplicationPageUserInfoPane } from '../../components/organisms/application/ApplicationPageUserInfoPane';
import { ApplicationPageUserSignInPane } from '../../components/organisms/application/ApplicationPageUserSignInPane';
import { ApplicationPageUserSummaryPane } from '../../components/organisms/application/ApplicationPageUserSummaryPane';
import { ApplicationPagePaymentInfoPane } from '../../components/organisms/application/ApplicationPagePaymentInfoPane';
import { ApplicationPageCompletePaneForMulticreator } from '../../components/organisms/application/ApplicationPageCompletePane';
import { ApplicationPageHomeLocationSelectionPane } from '../../components/organisms/application/ApplicationPageHomeLocationSelectionPane';
import { MultiCreatorFullPage } from '../multi_creator/MultiCreatorFullPage';
import { MulticreatorApplicationPageState } from './states/MulticreatorApplicationPageState';
import { MulticreatorStartDateSelectionPane } from '../../components/organisms/application/MulticreatorStartDateSelectionPane';
import { MulticreatorPackageSelectionPane } from '../../components/organisms/application/MulticreatorPackageSelectionPane';
import { MulticreatorConfirmationPane } from '../../components/organisms/application/MulticreatorConfirmationPane';

type Props = {};

@withNavigation(NavigationSpecs.application())
@observer
export class MulticreatorApplicationPage extends React.Component<Props> {
    @observable pageState = new MulticreatorApplicationPageState(GlobalStatesV3.currentUser, GlobalStatesV3.routing);

    componentDidMount() {
        this.pageState.init();
    }

    render() {
        return (
            <Provider applicationState={this.pageState}>
                <Switch>
                    <Route exact path={`/full/multicreators`} component={MultiCreatorFullPage} />
                    <Route
                        exact
                        path={V3Routes.multicreatorApplicationSignIn().stringify()}
                        component={ApplicationPageUserSignInPane}
                    />
                    <Route
                        exact
                        path={V3Routes.multicreatorApplicationUserInfo().stringify()}
                        component={ApplicationPageUserInfoPane}
                    />
                    <Route
                        exact
                        path={V3Routes.multicreatorApplicationUserSummary().stringify()}
                        component={ApplicationPageUserSummaryPane}
                    />
                    <Route
                        exact
                        path={V3Routes.multicreatorApplicationStartDateSelect().stringify()}
                        component={MulticreatorStartDateSelectionPane}
                    />
                    <Route
                        exact
                        path={V3Routes.multicreatorApplicationPackageSelect().stringify()}
                        component={MulticreatorPackageSelectionPane}
                    />
                    <Route
                        exact
                        path={V3Routes.multicreatorApplicationHomeLocationSelect().stringify()}
                        component={ApplicationPageHomeLocationSelectionPane}
                    />
                    <Route
                        exact
                        path={V3Routes.multicreatorApplicationSummary().stringify()}
                        component={ApplicationPageSummaryPane}
                    />
                    <Route
                        exact
                        path={V3Routes.multicreatorApplicationPaymentMethod().stringify()}
                        component={ApplicationPagePaymentInfoPane}
                    />
                    <Route
                        exact
                        path={V3Routes.multicreatorApplicationConfirmation().stringify()}
                        component={MulticreatorConfirmationPane}
                    />
                    <Route
                        exact
                        path={V3Routes.multicreatorApplicationComplete().stringify()}
                        component={ApplicationPageCompletePaneForMulticreator}
                    />
                </Switch>
            </Provider>
        );
    }
}
